/*****************************************************************************************
 * 설명 : 관리자 > 컨텐츠관리 > 컨텐츠 설정
 * URI : /admin/cms/menuList
*****************************************************************************************/
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Button from '@mui/material/Button';
import axios from 'axios';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as Yup from "yup";

import { ButtonEx, DateEx, InputEx, ToggleButtonGroupEx } from 'components/inputEx';
import alertMsg from 'components/message';

import { MESSAGE_DELAY, baseImgUrl, baseURL } from 'config/config';

import { Restful } from 'service/restful';
import { formatBytes, getExtensionOfFilename } from 'service/utils';

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
const TabBoardWrite = ( props ) => {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
	const [getApi] = Restful();
	const user = useSelector(state => state?.userInfo?.user);

	const [upload, setUpload] = useState([]);
	const [boardInfo, setBoardInfo] = useState({});

  const formik = useFormik({
		initialValues: {
			seq: '',
			boardId: '',
			groupId: '',
			boardIndex: '',
			subject: '',
			contents: '',
			noticeSdate: null,
			noticeEdate: null,
			screenTop: 0,
			screenLeft: 0,
			isLayerPopup: 0,
			popupWidth: 0,
			popupHeight: 0,
			isPopup: 0,
			isNotice: 0,
			isTitlelink: 0,
			titleLink: 0,
			status: 0,
			uploadFile: [],
      upload: []
		},
		validationSchema: Yup.object().shape({
			subject: Yup.string().max(255, "255자리").required('필수'),
			//contents: Yup.string().required('필수'),
			/*
			screenTop: Yup.number().typeError('숫자').nullable(),
			screenLeft: Yup.number().typeError('숫자').nullable(),
			popupWidth: Yup.number().typeError('숫자').nullable(),
			popupHeight: Yup.number().typeError('숫자').nullable(),
			titleLink: Yup.string().max(1000, "1000자리")
			*/
		}),
		onSubmit: (values) => {
			let params = {
				program: 'admin',
				service: 'board',
				action: 'setBoardWrite',
				version: '1.0',
				...values
			}

			if( values.contents.length < 1 ) {
				alertMsg("내용을 입력해 주시기 바랍니다.", "E", MESSAGE_DELAY);
				return false;
			}

			getApi("post", params).then( response => {
				if( response !== undefined && response.data.result ) {
					alertMsg(response.data.message, "S", MESSAGE_DELAY);

					props.setBoardFunc('list');

				} else {
					alertMsg(response?.data?.message || '서버와의 통신에 실패하였습니다.', 'E', MESSAGE_DELAY);
				}
			});
		}
  });

	/*******************************************************************************
    설  명 : 파일 업로드 시 처리
  *******************************************************************************/
		const handleChange = (e) => {
			if( e.target.files !== undefined && e.target.files.length > 0 ) {
				const files = e.target.files[0];

				if( files ) {
					uploadFile(files);
				}
			}
		};

		/*******************************************************************************
			설  명 : 파일 서버 업로드
		*******************************************************************************/
		const uploadFile = async(file) => {
			const formData = new FormData();
			formData.append('file',file)

			axios.post(baseImgUrl + '/file/file_upload.php', formData, {
				headers: {
						'content-type': 'multipart/form-data',
						'enctype': "multipart/form-data",
						'Access-Control-Allow-Origin': 'http://localhost:3000'
				}
			}).then(response => {
				let tmp = [...formik.values.uploadFile];
				tmp.push({
					seq: '',
					url: baseURL + response.data.url,
					fileSize: response.data.size,
					isDefault: 1,
					thumbnail: response.data.origin_filename,
					thumbnailFileName: response.data.url,
					uploadFile: baseURL + response.data.url,
					originalFilename: response.data.origin_filename
				});

				formik.setFieldValue('uploadFile', tmp);
			});
		}

	/***************************************************************************************
   * 설명 : 게시판 정보 가져오기
  ***************************************************************************************/
	const getBoardInfo = () => {
		if( ( formik.values.boardId ?? '' ) === '' ) return;

		let params = {
			program: 'admin',
			service: 'board',
			action: 'getBoardInfo',
			version: '1.0',
			boardId: formik.values.boardId
		}

		getApi("get", params).then( response => {
			if( response !== undefined && response.data.result && response.data.data && response.data.data.length > 0 ) {
				let tmp = response.data.data[0];
				setBoardInfo(tmp);

				if( tmp.authWriteLevel > user.level ) {
					alertMsg("해당 게시판에 쓰기 권한이 없습니다.", "E", MESSAGE_DELAY);
					props.close(false);
				}

			} else {
				setBoardInfo({});
			}
		});
	}

	/***************************************************************************************
	 * 설명 : 업로드 플러그인 처리
	***************************************************************************************/
	function uploadPlugin (editor) {
		editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
			return uploadAdapter(loader)
		};
	}

	/***************************************************************************************
	 * 설명 : 파일 업로드 처리
	***************************************************************************************/
	function uploadAdapter(loader) {
		return {
			upload: () => {
				return new Promise((resolve, reject) => {
					loader.file.then(file => {
						const files = file;

						if( files ) {
							return new Promise((resolve, reject) => {
								const reader = new FileReader();
								reader.readAsDataURL(file);
								reader.onloadend = () => {
									const base64 = reader.result;

									let fileBase64 = base64?.toString();

									let params = {
										program: 'app',
										service: 'camera',
										action: 'imageSave',
										version: '1.0',
										data: fileBase64?.substr(22)
									}

									getApi("post", params).then( (response) => {
										if( response !== undefined && response.data ) {
											setUpload({
												seq: '',
												thumbnail: response.data.thumbnail !== '' ? baseURL + response.data.thumbnail : baseURL + response.data.url,
												url: baseURL + response.data.url,
												filename: response.data.filename,
												filePath: response.data.url,
												fileSize: files.size,
												originalFilename: files.name
											});

											resolve({
												default: baseURL + response.data.url
											})

										} else {
											reject("error");
										}
									});
								};
								reader.onerror = error => reject(error);
							});
						}
					})
				});
			}
		};
	}

	/***************************************************************************************
	 * 설명 : 업로드한 파일을 삭제
	***************************************************************************************/
	const deleteUploadFile = (item, index) => {
		if( ! window.confirm("선택한 파일을 삭제하겠습니까?", "W", MESSAGE_DELAY)) return;

		// 현재 업로드된 파일인 경우
		let tmp = [...formik.values.uploadFile];

		tmp.splice(index, 1);

		formik.setFieldValue('uploadFile', tmp);

		if( ( item.seq ?? '' ) !== '' ) {
			let params = {
				program: 'admin',
				service: 'board',
				action: 'deleteUploadFile',
				version: '1.0',
				boardId: formik.values.boardId,
				seq: item.seq
			}

			getApi("post", params).then( response => {
				if( response !== undefined && response.data.result ) {
					alertMsg(response.data.message, "S", MESSAGE_DELAY);

				} else {
					alertMsg(response?.data?.message || '서버와의 통신에 실패하였습니다.', 'E', MESSAGE_DELAY);
				}
			});
		}
	}

	/***************************************************************************************
	 * 설명 : CK에디터에 이미지 추가
	***************************************************************************************/
	const contentsAddImage = (item) => {
		let contents = formik.values.contents;

		contents += `<img src="${item.url}" alt="${item.originalFilename}" />`;

		formik.setFieldValue('contents', contents);
	}

	/***************************************************************************************
	 * 설명 : 업로드 된 파일리스트 가져오기
	***************************************************************************************/
	const getUploadFileList = () => {
		let params = {
			program: 'admin',
			service: 'board',
			action: 'getUploadFile',
			version: '1.0',
			boardId: formik.values.boardId,
			boardSeq: formik.values.seq
		}

		getApi("get", params).then( response => {
			if( response !== undefined && response.data.result && response.data.data && response.data.data.length > 0 ) {
				formik.setFieldValue('uploadFile', response.data.data);

			} else {
				formik.setFieldValue('uploadFile', []);
			}
		});
	}

	/***************************************************************************************
   * 설명 : CK에디터에서 이미지 업로드 시 처리
  ***************************************************************************************/
  useEffect(() => {
    if( (upload.originalFilename ?? '' ) !== '' ) {
      let tmp = [...formik.values.uploadFile];

      tmp.push(upload);

      formik.setFieldValue('uploadFile', tmp);
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [upload]);

	/***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  useEffect(() => {
		if( props.tabIndex === 2 && props.siteSeq !== undefined ) {
			formik.setFieldValue('siteSeq', props.siteSeq );
		}

		// eslint-disable-next-line
  }, [props.siteSeq]);

	/***************************************************************************************
   * 설명 : 게시판 정보 가져오기
  ***************************************************************************************/
	useEffect(() => {
		if( (formik.values.boardId ?? '') !== '' ) {
			getBoardInfo();

			// 업로드 된 파일 리스트 정보 가져오기
      getUploadFileList();
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formik.values.boardId])

	/***************************************************************************************
   * 설명 : 등록/수정 시 처리
  ***************************************************************************************/
  useEffect(() => {
		if( props.tabIndex === 2 && props.data !== undefined && props.data !== null ) {
			const tmp = props.boardData.data.contents === '' || props.boardData.data.contents === null || props.boardData.data.contents === undefined ? '' : props.boardData.data.contents;

			if (props.boardData.data.boardId !== undefined && props.boardData.data.boardId !== null) {
				formik.setValues(props.boardData.data);

			} else {
				formik.setFieldValue('boardId', props.boardData.boardId );
				formik.setFieldValue('groupId', props.boardData.groupId );
			}

			// setContents(tmp);
			formik.setFieldValue('contents', tmp);
		}

	// eslint-disable-next-line
  }, [props.data, props.tabIndex]);

  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
	return (
		<>
			{props.siteSeq === '' &&
				<section className="pt10">
					<div className="menu-list-add-background">
					사이트를 선택 후에 '메뉴등록' 혹은 '메뉴선택'을 진행해주세요.
					</div>
				</section>
	  	}

			{props.siteSeq !== '' &&
				<>
					{ ( props.data.seq === undefined || props.data.siteSeq === undefined ) &&
						<section className="pt10">
							<div className="menu-list-add-background">
								메뉴를 선택하시기 바랍니다.
							</div>
						</section>
					}

					{ props.data.seq !== undefined && props.data.siteSeq !== undefined &&
						<section className="pt10">
							<form onSubmit={formik.handleSubmit}>
								<header>
									<div className="right">
										<Button
											color="inherit"
											variant="contained"
											className="Btn"
											onClick={() => props.setBoardFunc('list')}
										>목록으로</Button>

										<ButtonEx
											title="게시글 저장"
											auth={formik.values.seq === 0 || formik.values.seq === '' ? "authWrite" : "authModify"}
											type="submit"
											color="primary"
											variant="contained"
											className="Btn ml5"
										/>
									</div>
								</header>

								<div className="mt10" style={{width: 'calc(100% - 2px)'}}>
									<table className="input-table">
										<colgroup>
											<col style={{width: '15%'}} />
											<col style={{width: '35%'}} />
											<col style={{width: '15%'}} />
											<col style={{width: '35%'}} />
										</colgroup>

										<tbody>
											<tr>
												<th scope="row"><label htmlFor="subject">제목</label></th>
												<td colSpan={3}>
													<InputEx
														name="subject"
														formik={formik}
														fullWidth={true}
													/>
												</td>
											</tr>
											<tr>
												<th scope="row"><label htmlFor="isNotice">공지글 여부</label></th>
												<td>
													<ToggleButtonGroupEx
														name="isNotice"
														exclusive={true}
														formik={formik}
														fullWidth={false}
														data={[
															{label: '공지글', value: 1},
															{label: '일반글', value: 0}
														]}
													/>
												</td>
												{parseInt(formik.values.isNotice) === 0 &&
													<td colSpan={2}></td>
												}
												{parseInt(formik.values.isNotice) === 1 &&
													<>
														<th scope="row"><label htmlFor="noticeSdate">공지 기간</label></th>
														<td>
															<DateEx
																type="date"
																name="noticeSdate"
																formik={formik}
																fullWidth={false}
																className="search-input-btn"
																style={{width: '150px'}}
															/>
															<span className="ml5 mr5 lh38px">~</span>
															<DateEx
																type="date"
																name="noticeEdate"
																formik={formik}
																fullWidth={false}
																className="search-input-btn"
																style={{width: '150px'}}
															/>
														</td>
													</>
												}
											</tr>

											{ boardInfo.authFileUploadLevel <= user.level &&
												<tr>
													<th className="p10">첨부파일</th>
													<td className="" colSpan={3}>
														<div>
															<InputEx
																type="file"
																name='file'
																id="name"
																formik={formik}
																onChange={(e) => handleChange(e)}
															/>
														</div>

														{ Array.isArray(formik.values.uploadFile ?? []) && (formik.values.uploadFile ?? []).length > 0 &&
															<div className="mt10">
																{
																	formik.values.uploadFile.map((item, index) => {
																		return (
																			<div key={index} className="mt10">
																				<Button
																					variant='outlined'
																					color="default"
																					className="Btn cred mr10"
																					onClick={() => deleteUploadFile(item, index)}
																				>X 삭제</Button>

																				{['JPG', 'JPEG', 'GIF', 'PNG', 'BMP', 'TIFF'].includes(getExtensionOfFilename(item.originalFilename)) &&
																					<Button
																						variant='outlined'
																						color="primary"
																						className="Btn mr10"
																						onClick={() => contentsAddImage(item)}
																					>↓↓↓ 에디터 삽입</Button>
																				}

																				{item.originalFilename}
																				<span className="f11 ml5">({formatBytes(item.fileSize)})</span>
																			</div>
																		);
																	})
																}
															</div>
														}
													</td>
												</tr>
											}
										</tbody>
									</table>

									<div id="CKEditor" className="mt5" style={{height: 'calc(100vh - 300px)'}}>
      	            <CKEditor
											editor={ Editor }
											data={formik.values.contents || ''}
											config={{
												htmlSupport: {
													allow: [
														{ // to keep all the html tags and their attributes
																name: /.*/,
																attributes: true,
																classes: true,
																styles: true
														},
														{
																name: 'a',
																attributes: {
																	target: true
																}
														}
													]
												},
												extraPlugins: [uploadPlugin],
                        placeholder: "내용을 입력하세요"
											}}
											onReady={ editor => {
												editor.data.set(formik.values.contents || '');
											}}
											onChange={ ( event, editor ) => {
												const text = editor.getData();
												formik.setFieldValue('contents', text);
											}}
											onBlur={ ( event, editor ) => {
												const text = editor.getData();
												formik.setFieldValue('contents', text);
											}}
											onFocus={ ( event, editor ) => {
											}}
										/>
									</div>
								</div>
							</form>
						</section>
					}
				</>
			}
		</>
  );
}

/*****************************************************************************************
 * 설명 : default export 선언
*****************************************************************************************/
export default TabBoardWrite;